import { Meta } from "../../../meta/meta";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Loader } from "../../../components/ui/loader";
import { GoBack } from "../../../components/ui/goBack";
import { removeFileExtensions } from "../../../utils/formatters";
import { docx, pdf, searchIconSmall } from "../../../assets/svgs";
import { Paginator } from "../../../components/ui/paginator";
import { useTanstackById } from "../../../hooks/useTanstack";
import { getDownload } from "../../../utils/helpers";
import styles from "./styles.module.scss";

const ModelFour = ({
  id,
  title_am,
  title_en,
  description_am,
  description_en,
  image,
}) => {
  const { t } = useTranslation();
  const { language } = useParams();
  const { data } = useTanstackById("getWebSingleItem", id);

  const [flightSearch, setFlightSearch] = useState("");
  const [currentItems, setCurrentItems] = useState([]);

  const title = language === "am" ? title_am : title_en;
  const description = language === "am" ? description_am : description_en;

  const itemsPerPage = 5;

  useEffect(() => {
    const filteredFiles = data?.files?.filter(({ stored_name }) =>
      removeFileExtensions(stored_name)
        ?.toLowerCase()
        ?.includes(flightSearch?.toLowerCase())
    );
    setCurrentItems(filteredFiles?.slice(0, itemsPerPage));
  }, [data, flightSearch]);

  const handlePageChange = (itemOffset, itemsPerPage) => {
    const filteredFiles = data?.files?.filter(({ stored_name }) =>
      removeFileExtensions(stored_name)
        ?.toLowerCase()
        ?.includes(flightSearch?.toLowerCase())
    );
    setCurrentItems(
      filteredFiles?.slice(itemOffset, itemOffset + itemsPerPage)
    );
  };

  return (
    <>
      <Meta title={title} description={description} image={image} />
      {!data ? (
        <Loader />
      ) : (
        <main className={styles.modelFour}>
          <div className="container">
            <div className={styles.modelFour_context}>
              <GoBack />

              <h1>{data?.name}</h1>

              <div className={styles.modelFour_form}>
                <div className={styles.modelFour_formSecondary}>
                  <input
                    type="text"
                    aria-label={t("flight_query")}
                    value={flightSearch}
                    required={!flightSearch ? true : false}
                    onChange={(e) => setFlightSearch(e.target.value)}
                  />
                  <button type="submit" aria-label="search">
                    {searchIconSmall.icon}
                  </button>
                </div>
              </div>
            </div>

            {currentItems?.length ? (
              <ul className={styles.modelFour_files}>
                {currentItems?.map(({ name, stored_name }) => (
                  <li key={name} onClick={() => getDownload(name)}>
                    {removeFileExtensions(stored_name)}
                    <span>{name?.includes("pdf") ? pdf.icon : docx.icon}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className={styles.modelFour_noItems}>0 {t("search_result")}</p>
            )}

            {data?.files?.length > itemsPerPage && (
              <Paginator
                data={data?.files}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            )}

            {data?.links?.length ? (
              <ul className={styles.model_links}>
                {data?.links?.map((el) => (
                  <li key={el.id}>
                    <a href={el} target="/blank" rel="noreferrer">
                      {el}
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        </main>
      )}
    </>
  );
};

export default ModelFour;
